import { create } from 'zustand';

export const useAuthStore = create((set) => ({
  user: null,
  isAuthenticated: false,
  signedOut: false,

  setAuth: (user) => set({ user, isAuthenticated: true, signedOut: false }),
  clearAuth: ({ signedOut = false } = {}) => set({ user: null, isAuthenticated: false, signedOut }),
}));
